import GraphikArabicMedium from "assets/fonts/graphik-arabic-medium.woff2";
import GraphikArabicRegular from "assets/fonts/graphik-arabic-regular.woff2";
import GraphikMedium from "assets/fonts/graphik-medium.woff2";
import GraphikRegular from "assets/fonts/graphik-regular.woff2";
import { dropdownMenu } from "components/dropdown/dropdown.styles";
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
    v2.0 | 20110126
    License: none (public domain)
  */

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    font-family: 'Graphik', 'GraphikArabic', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    vertical-align: baseline;
  }

  /* setting font size to 10px for easier rem calculations */
  html { font-size: 62.5%; };

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol, ul {
    list-style: none;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .ant-typography strong {
    font-weight: 500;
  }

  .prflbx{
        img{
          max-width: 125px;
        }
  }
  {}
  @font-face {
    font-family: 'Graphik';
    font-weight: 400;
    src: url(${GraphikRegular}) format('woff2');
  }

  @font-face {
    font-family: 'Graphik';
    font-weight: 500;
    src: url(${GraphikMedium}) format('woff2');
  }

  @font-face {
    font-family: 'GraphikArabic';
    font-weight: 400;
    src: url(${GraphikArabicRegular}) format('woff2');
  }


  @font-face {
    font-family: 'GraphikArabic';
    font-weight: 500;
    src: url(${GraphikArabicMedium}) format('woff2');
  }

  .ant-picker-dropdown {
    .ant-picker-today-btn {
      color: ${({ theme }) => theme.colors.greenLight};

      &:hover {
        color: ${({ theme }) => theme.colors.greenDark};
      }
    }
  }


  .day_v_head .sc-kDvujY.kdHSeD {
    gap: 10px !important;

    // flex-wrap:wrap;
}
  .filter_day_v {
    // background: #fff; padding: 4px 6px; border-radius: 6px; border: 1px solid #00473A;

    .ant-select-selector {
      padding: 0px !important;

      .ant-select-selection-placeholder {
        padding-inline-end: 30px;
      }
    }
}




 @media(max-width:900px){

 #week-view-filters-form{
  .sc-gKPRtg{
    .sc-iBYQkv{
      .ant-form-item{
        margin-bottom:0px;
        .ant-row{
          .ant-col{
            label{
              font-weight: 500;
            }
          }
        }
      }
    }
  }
 }

 .packForm .alart_wrapp{ position: unset !important; margin-bottom: 10px; }

  .sc-dkKxlM{ 
    display: flex; 
    .sc-knEsKG{
      flex-wrap: wrap;
    }
  }

  .global_slots{
    .slot_mbl{
      .halfHours{
        .sc-ckEbSK{
          display: flex; align-items: center;
          span.ant-typography{
            display:none;
          }
          .sc-GhhNo{
            width: 100%;
            span{
              display:inline-block;
            }
          }
        }
      }
    }
  }

  .day_v_head .sc-kDvujY{ display:block !important; }
  .filter_day_v{ min-width:50% !important; width:50%; margin-bottom: 6px !important; }
  .filter_day_v span.ant-select-clear {
    opacity: 1; width: 25px; height: 25px; background: #edeff6; display: flex; align-items: center; justify-content: center; 
    font-size: 30px; border-radius: 50%; top: 13px; right: 3px;
  }
  .stats_detls .row{ flex-wrap:wrap;  }
  .stats_detls .row .col:nth-child(2) { padding-right: 0;}
  .stats_detls .row .col { max-width: 25% !important; width: 25% !important; }  
  .stats_detls .row .col + .col{padding-left: 10px !important;}
  .stats_detls .row .col:last-child{ padding-right:0px; } 
  .stats_detls .row .col .stats_bx{ height: 40px !important; padding: 0px 5px !important; }
  .stats_detls .row .col .stats_bx span{font-size:8px !important}
  .stats_detls .row .col .stats_bx h4{font-size:12px !important;line-height: 10px;}
  // .slot_wrap.week_view_clg .slot_cell .sc-iOeugr{overflow:hidden}

  .anticon svg{width:20px;}



  .ant-space-item .ant-modal-content .ant-modal-footer .sc-hLBbgP button.ant-btn { position: static; }
  .ant-space-item .sc-pyfCe .day_v_head a { right: 0 ;}
  .ant-row.fixed_bk_in{
    .ant-col{
      .ant-row.booking_dtls{
        .ant-col{
          .ant-row{
            .ant-col{max-width: 170px;width: auto;
            }
          }
        }
      }
    }
  }

  .ant-space-item .sc-pyfCe{
    &.cmpny_head{
      .day_v_head{
        .sc-csuSiG{
          .ant-typography{
            // overflow: hidden; text-overflow: ellipsis; display: inline-block; width: 61%;
          }
        }
      }
    }    
  }
  .ant-modal-wrap .ant-modal-content .ant-modal-body .ant-form .sc-gKPRtg .sc-iBYQkv .ant-form-item .ant-col.ant-form-item-control .ant-form-item-control-input .ant-picker span.ant-picker-clear {
    opacity: 1 !important; inset-inline-end: 11px !important;
  }

  .ant-picker-dropdown{
    left: 10px !important; margin: 0px; padding: 0px; right: 10px;
    .ant-picker-range-wrapper{
      padding: 15px; width: 100%;
      .ant-picker-panel-container{
        .ant-picker-panel-layout{
          display:block;
          .ant-picker-presets{
            width: 100%; min-width: 100%; max-width: 100%; display: block; border-bottom: 1px solid #ccc;
            ul{
              height: auto; display: flex; align-items: center; justify-content: space-between;
              li{
                font-size:14px;
                & + li{
                  margin:0px;
                }
              }
            }
          } 
  
          .ant-picker-panels{
            overflow: auto; width: 100%;
            // display:block;
            .ant-picker-panel{
              width:100%;
              .ant-picker-date-panel{
                width:100%;
                .ant-picker-body{
                  .ant-picker-content{
                    width:100%;
                  }
                }
              }
            }
          }
  
        }
      }
    }
  }

}
 


  // Remove the flex gap from component

  .no-gap {
     gap: 0;
  }

  .ant-space-item{
    .sc-idXgbr.cdZltE{
      margin-top:15px;
    }
  }

  .stats_detls {
    margin-bottom: 15px;
    .row {
      display: flex; align-items: center;
      .col {
        max-width: 33.3%; width: 33.3%;
        &:nth-child(1) .stats_bx{
          background:#4E7E4C; 
          // span{color:#df9c5a;}
          // h4{ color:#975e26;}
        }
        &:nth-child(2) .stats_bx{
          background:#009EDB; 
          // span{color:#6b9d9d;}
          // h4{ color:#2e7070;}
        }
        &:nth-child(3) .stats_bx{
          background:#015B97; 
          // span{color:#8666b5;}
          // h4{ color:#5e359b;}
        }
        &:nth-child(4) .stats_bx{
          background:#CD7640; 
          // span{color:#5fa978;}
          // h4{ color:#31874e;}
        }
        
        .stats_bx {
          background: #fff; padding: 10px; border-radius: 5px; border: 1px solid #dbdbdb;height: 50px;position:relative;
          display:flex;
          justify-content:space-between;
          align-items:center;

          span {
            font-size: 14px; color: #4f5051; font-weight: 500; color:#fff;
          }
          h4 {
            font-size: 20px; color: #00473a; font-weight: 500; text-align:right; color:#fff;
          }
          &:hover{
            box-shadow:0px 1px 6px #00473a40; 
          }         
        }
        & + .col{
          padding-left:15px;
        }

      }
    }
  }
 
  
   


  .loader {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #00473a;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    position: absolute;
    right: 13px;
    bottom: 11px;
}
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }








  /* 24-02-2024 All Booking Page / Vikas / */


 

.ant-space-item{

  .sc-pyfCe{
    position: relative;    
    .sc-jrcTuL{    
      width: 100%; display: block; grid-template-columns: auto auto auto; gap: 0px 10px; align-items: start;           
      .sc-csuSiG{
        width: 100%;  grid-column: 1 / span 3; margin-bottom: 10px;
        h3{
          margin:0px;
        }
      }
      
      .sc-kDvujY:nth-child(2){
        display: inline-block; vertical-align: top;
        .sc-kgTSHT {
          min-width: 110px; margin: 0px; padding: 0px;
          .ant-select-selector{
            .ant-select-selection-item{
              padding-inline-end: 25px; 
            }
            .ant-select-selection-placeholder{
              padding-inline-end: 25px; font-size:14px;
            }
          }
        }
      }
      
      .sc-kDvujY:nth-child(3){     
        display: inline-block;
        
        .sc-eDvSVe{
          padding:0px; background: transparent;
          .ant-form{
            align-items: center; gap:10px;
            .sc-gKPRtg{
              flex-direction: row;
              .sc-iBYQkv{
                gap:10px;
                .ant-form-item {
                  margin:0px;                  
                  
                  &:nth-child(3){ width: 135px; }
                  &:nth-child(2){ width: 115px; }

                  &:nth-child(1){
                    .ant-row{
                      flex-direction: unset;
                      .ant-col{
                        .ant-form-item-control-input{
                          .ant-form-item-control-input-content{
                            .ant-picker{
                              max-width: 195px; padding: 4px 7px;
                              .ant-picker-input{}
                              .ant-picker-range-separator{
                                display:none;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  &:nth-child(2){}
                  &:nth-child(3){}

                  .ant-row{
                    flex-direction: unset;
                    .ant-col{
                      label{
                        display:none;
                      }
                    }
                  }
                }
              }
              .sc-ftTHYK{
                display: flex; height: auto; padding-left:10px;
                .ant-form-item{
                  margin:0px;
                  & + .ant-form-item{
                    margin-left:10px;
                  }
                  .ant-row{
                    flex-direction: unset;
                    .ant-col{
                      label{
                        display:none
                      }
                    }
                  }
                }
              }
            }
            .sc-hLBbgP{
              width: auto; margin: 0px;
              .ant-btn{
                position: relative;
                

                &:nth-child(2){}
                &:nth-child(3){
                  display:none;
                }
              }
            }
          }
        }
      }
    }
  }
}








  @media (min-width: 1024px) and (max-width: 1450px) {

    .ant-space-item{
      .sc-dkKxlM{
        margin:0px 0px 10px 0px;
      }

    .sc-pyfCe{
      // display: block; 
      position: relative; margin-bottom: 10px;      
        .ant-btn.ant-btn-default {
          padding: 5px 10px; font-size: 12px; height: auto;border-color: #d9d9d9; color: rgba(0, 0, 0, 0.88) ;
        }  
      .sc-jrcTuL{    
        width: 100%; display: block; grid-template-columns: auto auto auto; gap: 0px 10px; align-items: start;           
          .sc-csuSiG{
            width: 100%;  grid-column: 1 / span 3; margin-bottom: 10px;
            h3{
              margin:0px;
            }
          }
          .sc-kDvujY:nth-child(2){
            display: inline-block; vertical-align: top;
            // width: 29%;
              .sc-kgTSHT {
                min-width: auto; 
                .ant-select-selector{
                  .ant-select-selection-item{
                    padding-inline-end: 25px; font-size:12px;
                  }
                  .ant-select-selection-placeholder{
                    padding-inline-end: 25px; font-size:12px;
                  }
                }
              }
          }
        .sc-kDvujY:nth-child(3){     
          display: inline-block; 
          // width: 71%;
          
          .sc-eDvSVe{
            padding:0px; background: transparent;
            .ant-form{
              align-items: center; gap:10px;
              .sc-gKPRtg{
                flex-direction: row;
                .sc-iBYQkv{
                  gap:5px;
                  .ant-form-item {
                    margin:0px;     
                    
                    .ant-row{
                      .ant-col{
                        .ant-form-item-control-input{
                          .ant-form-item-control-input-content{
                            .ant-input{
                              font-size:12px; padding-left: 7px; padding-right: 7px;
                            }
                          }
                        }
                      }
                    }
                    
                    &:nth-child(3){ width: 115px; }
                    &:nth-child(2){ width: 115px; }
  
                    &:nth-child(1){
                      .ant-row{
                        flex-direction: unset;
                        .ant-col{
                          .ant-form-item-control-input{
                            .ant-form-item-control-input-content{
                              .ant-picker{
                                max-width: 170px; padding: 4px 5px;                             
                                .ant-picker-input{
                                  input{
                                    font-size:12px;
                                  }
                                }
                                .ant-picker-range-separator{
                                  display:none;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  
                   
  
                    .ant-row{
                      flex-direction: unset;
                      .ant-col{
                        label{
                          display:none;
                        }
                      }
                    }
                  }
                }
                .sc-ftTHYK{
                  display: flex; height: auto; padding-left:10px;
                  .ant-form-item{
                    margin:0px;
                    & + .ant-form-item{
                      margin-left:10px;
                    }
                    .ant-row{
                      flex-direction: unset;
                      .ant-col{
                        label{
                          display:none
                        }
                        .ant-form-item-control-input{
                          .ant-form-item-control-input-content{
                            .ant-select{
                              .ant-select-selector{
                                padding: 0 7px; height:28px;
                                .ant-select-selection-search{
                                  .ant-select-selection-search-input{
                                    font-size:12px; height:28px;
                                  }
                                }
                                .ant-select-selection-item{
                                  display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                                  font-size: 12px; width: 95px;
                                }
                                .ant-select-selection-placeholder{
                                  font-size:12px;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              .sc-hLBbgP{
                width: auto; margin: 0px;
                .ant-btn{
                  font-size: 12px; height:28px; padding-top: 4px;
                  
                  &:nth-child(3){
                    display:none;
                  }

                }
              }
            }
          }
        }
      }      
    }        
  }  
}



  .sc-idXgbr{
    margin-top: 20px;
  }
  .ant-space-item .sc-khsqcC {
    margin-top: 16px !important;
}


#booking-filters-form .ant-form-item .ant-col.ant-form-item-control .ant-picker span.ant-picker-clear {
  inset-inline-end: 5px;
}
 

.ant-space-item .sc-pyfCe .sc-bRlCZA .ant-btn.ant-btn-default.ant-btn-dangerous { 
 color: #ff4d4f; border-color: #ff4d4f;
  span{
    color: #ff4d4f;
  }
}



span.ant-typography.ant-typography-secondary.css-inhf9z { font-size: 13px;}


.day_view_clg{  
  .sc-jfTVlA{
    height: calc(100vh - calc(185px + 32px)); overflow: auto; overflow: auto;    
    .sc-hiDMwi{ overflow:visible;}
    .sc-iOeugr{
      background:#f5f5f5;
      .sc-jfvxQR{
        .field_mbl{
          .sc-jOiSOi, .sc-dPWrhe{
            display:none;
          }
        }
      }
    }
  }
  .sc-lbVpMG{ position: sticky; top: 0px; z-index: 3; background: #fff; left: 0px;}
  .sc-iOeugr{ position: sticky; top: 0px; z-index: 2; overflow: visible; padding-right:0px;}
  .sc-eJDSGI{ position: sticky; left:0px; overflow: visible; background: #fff; }
}


.bknghead{
  .day_v_head{}
  .mltyplbtn{
    position: absolute; right: 0; top: 0;
    .ant-btn.ant-btn-default{}
  }
}

.cstmhead{
  display:flex;
  .day_v_head{}
  .mltyplbtn{
    .ant-space-item{
      & + .ant-space-item{
        .ant-btn.ant-btn-default{}
      }
    }
    .ant-btn.ant-btn-default{}
  }
}

.cstmtablecs{
  .ant-table-wrapper{
    .ant-spin-container{
      .ant-table{
        .ant-table-container{
          .ant-table-content{
            table{
              width:100%;
              tr{
                th{
                  &:last-child{
                    width:160px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}


.sidebarl{
  .ant-layout-sider{
    .ant-layout-sider-children{
      .ant-menu{
        padding-bottom: 50px;
      }
    }
  }
}


.pgtl_zmbtn{
  display: flex; align-items: center; justify-content: space-between; margin-bottom:15px;
  .sc-dkKxlM{margin-bottom:0px;}
  .sc-khsqcC{margin-bottom:0px;}
  .mzbtngrp{
    displaY:none; align-item:center;
    .btn{
      padding:3px 10px; display: flex; align-items: center; font-weight: 500;
      .ttlNm{
        font-size:14px; margin-left: 5px;
      }
      svg{width:15px; height:15px;}
      & + .btn{
        margin-left:10px;
      }
    }
  }
}

.onlymbl_zoomng{
  .button_group{display:none;}
}

@media screen and (max-width: 980px) {  

  .stats_bx {
          height: 120px !important;
          display:block !important;
  }
           

.onlymbl_zoomng{
  display: flex; align-items: center; justify-content: space-between; margin-bottom:0px;
  .button_group{
    // displaY:flex; align-item:center; display:none;
    .btn{
      padding:3px 10px; display: flex; align-items: center; font-weight: 500;      
      svg{width:15px; height:15px;}
      & + .btn{
        margin-left:10px;
      }
    }
  }
}

.pgtl_zmbtn{ display: none; }


// .ant-layout-content{
//   .ant-space{
//     .ant-space-item{
//       .stats_detls{
//         display:none;
//       }
//     }
//   }
// }


  
  .anticon.anticon-menu.app-header-hamburger-mobile{ display:inline-flex; }

  .ant-layout-sider-below.side-bar-sider{    
    &:after{
      content: ''; background: #00473a14; left: 0px; right: 0px; top: 0px; bottom: 0px; position: fixed; z-index: -1;
    }
    &.ant-layout-sider-collapsed.ant-layout-sider-zero-width, &.ant-layout-sider-collapsed.ant-layout-sider-has-trigger {
      &:after{
        display: none;
      }  
    }
  }

  .cmpny_head{
    .day_v_head{
      .mltyplbtn{
        position: unset; right: 0; top: 0;        
      }
    }
  }

  .slot_wrap.week_view_clg{
    .slot_cell{
      .sc-iOeugr{
        position: sticky; top: 0px; z-index: 9; background: #f5f5f5;
      }
    }
  }

  .bokd_slot.nbsbx{
    .ant-typography{
      // line-height: 11px;
      // strong{font-size:10px;}
    }
      .nsprng{
        .sc-fbYMXx{
          .sc-fXqpFg{
            .ant-typography{
              
            }
          }
        }
      }
  }
 

  .cstmhead{    
    .day_v_head{
      .sc-csuSiG{
        gap: 5px;
        .ant-typography{
          white-space:normal; font-size: 20px;
        }
      }
      .mltyplbtn{
        position: unset; right: 0; top: 0;
      } 
      .sc-kDvujY{
        .sc-jSUZER{
          .ant-modal-root{
            .ant-modal-wrap{
              .modal-mobile{
                .ant-modal-content{
                  display:block;
                }
              }
            }
          }
        }
      }       
    }     
  }



  .day_view_clg{
    .sc-jfTVlA{
      grid-template-rows: 120px auto !important;
      .sc-iOeugr{
        .sc-jfvxQR{
          .field_mbl{
            .ant-typography.ant-typography-ellipsis{
              font-size:14px;
            }
            .sc-cOxWqc{display:none;}
            .sc-dPWrhe{display:none;}
            .sc-jOiSOi{display:none;}
          }
        }
      }
    }
    .slot_mbl{
      .halfHours{
        .sc-ckEbSK{
          display: flex; align-items: unset; line-height: 42px;
          span.ant-typography{
            display:none;
          }
          .sc-GhhNo{
            width: 100%;
            span{
              display:inline-block; 
              line-height:29px;
              // line-height: 42px;
            }
          }
        }
      }
    }
  }  
}
    
  
  
}



.week_view_clg{
  .slot_cell{
    overflow:auto;
    .timdbx{overflow:visible;}
    .global_slots{overflow:visible;}
  }
}





  ${dropdownMenu};

  .input-prefix-icon { color: ${({ theme }) =>
    theme.antd.colorIcon}; margin-right: 8px; };



  // social match feature

  .ques_card {
    border: 1px solid #f0f0f0;
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    line-height: 1.5714285714285714;
    list-style: none;
    font-family: 'Graphik', 'GraphikArabic';
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 15px;
  }
  
  .ques_card .head_bx {
    position: relative;
  }
  
  .ques_card .head_bx .icon {
    position: absolute;
    right: -5px;
    background: #000;
    border-radius: 100px;
    font-size: 12px;
    color: #fff;
    padding: 3px;
    top: -6px;
    width: 18px;
    height: 18px;
  }
  
  .ques_card .head_bx .ant-row {
    justify-content: end;
  }
  
  .ques_card .option_item {
    padding: 10px;
  }
  .ques_card .option_item .ant-form-item {
    margin: 0;
  }
  ul.list_user {}
  
  ul.list_user li {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.88);
      text-transform: capitalize;
  }
  
  ul.list_user li span:first-child {
      display: inline-block;
      width: 100%;
      max-width: 19%;
      margin-bottom: 10px;
  }
  
  ul.list_user li span:last-child {
      font-weight: 500;
  }
  
  .btn_rgt{    margin-left: auto;
    display: block;}
  
  
  
    .ant-modal.right-modal {
      padding-bottom: 0;
      float: right;
      height: 100%;
      top: 0;
      background: #fff;
  }
  
  .ant-modal.right-modal .ant-modal-content {
      border-radius: 8px 0px 0px 8px;
      height: auto;
      box-shadow: none !important;
      padding: 0px;
  }
  .ant-modal.right-modal .ant-modal-header {
    background: #76B584;
    border-radius: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0 !important;
    padding: 10px 20px;
  }
  .user_avtar .media {
    width: 60px;
    height: 60px;
  }
  
  .user_avtar {
    display: flex;
    align-items: center;
  }
  
  .user_avtar .media img {
    width: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 100%;
    overflow: hidden;
  }
  .plr_list_edit .cell .cellsub .media img{ object-fit: cover;
    object-position: center;}
  .user_avtar .ant-typography {
    font-size: 18px;
    color: #000;
    margin-left: 10px;
    text-transform: capitalize;
  }
  .ant-modal.right-modal .ant-modal-header .ant-modal-title {
    color: #fff;
    font-size: 20px !important;
  }
  .list_user {
    display: grid;
    grid-template-columns: repeat(2,1fr);
  }
  .ant-modal.right-modal .ant-modal-content .ant-modal-body {
    padding: 0px 12px;
    margin-top: 0px;
  }
  .modal_social .ant-modal-body {
    overflow: initial;
  }
  .ant-collapse-header-text .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  
  .inti_user01 {
    position: absolute;
    top: 10px;
    width: 100%;
    max-width: 50%;
    right: 0;
    display: flex;
    justify-content: end;
    align-items: center;
  }
  
  .inti_user02 {
    position: absolute;
    width: 100%;
    max-width: 50%;
    right: 0;
    display: flex;
    justify-content: end;
    align-items: center;
    bottom: 18%;
  }
  
  .inti_user02 .ant-form-item-control-input {
    min-height: 60px;
  }
  
  .inti_user02 .ant-input,.inti_user01  .ant-input{
    height: 45px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
  }
  .question_ans .ad {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 15px;
    background: #FFF;
    -moz-box-shadow: 0 1px 5px -1px rgba(0, 0, 0, .13);
    -webkit-box-shadow: 0 1px 5px -1px rgba(0,0,0,.13);
    box-shadow: 0 1px 5px -1px rgba(0,0,0,.13);
    border-bottom: 1px solid #dedede;
    position: relative;border-radius:7px;
  }
  .question_ans .ad .ques_no {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .question_ans .ad .ques_no h3 {
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
  }
  
  .question_ans .ad .ques_no .btn_edit {
    display: flex;
    align-items: center;
  }
  
  
  .question_ans .ad .ques_no .btn_edit .anticon-edit {}
  
  .question_ans .ad .ques_no .btn_edit .ant-switch-checked {
    margin-left: 10px;
  }
  ul.ans_list {padding: 7px 15px;
    display: grid;
    align-items: center;
    grid-template-columns: repeat(3,1fr);
  }
  
  ul.ans_list li {
    display: inline-block;
    margin-top: 15px;
    font-size: 16px;
    font-weight: 400;
  }
  
  
  .ant-modal.right-modal .ant-modal-header {
    background: #00473A!important;
  }
  .question_ans .ad .ques_no {
    background: #f0f0f0;
    border-bottom: 1px solid #d9d9d9;
    padding: 7px 15px;
  }
  
  .option_ques {
    display: flex;
  }
  
  .option_ques .option_item {
    width: 50%;
  }
  .right-modal button.ant-modal-close {
    color: #fff;
    top: 14px!important;
  }
  .plsection .plr_list .cell { align-items: center;}
  .plsection .plr_list .cell .add_bydef {
    width:70px;
    height: 70px;
    border: 2px dashed #53a869;
    margin-left: 20px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    color: #53a869;
    font-size: 20px;
    justify-content: center;
    margin-right: 20px;
  }
  .text_Quill .ql-container.ql-snow {
    height: calc(100vh - 200px);
  }
    ${dropdownMenu};
   
    .input-prefix-icon { color: ${({ theme }) =>
      theme.antd.colorIcon}; margin-right: 8px; };
  
  
  
    .sm_pndl{
      margin-top: 30px;
      text-align:center;
      .smpnm{
        display: flex; align-items: center; justify-content: center; margin-bottom: 7px;
        .media{
          img{ width: 100%; max-width: 28px;}
        }
        .smttl{ margin-left: 7px; font-size: 16px; color: #000; font-weight: 500;}
      }
  
      .sm_mttl{
        display: flex; align-items: center; justify-content: center; margin-bottom: 5px;
        .media{
          img{width:100%; max-width:50px;}
        }
        .smpnttl{
          text-align:left; margin-left:10px;
          h3{margin: 0px; color: #1F1F1F; font-size: 18px; font-weight: 500;}
          p{font-size:14px; margin:0px; color:#5B6683}
        }
      }
  
      .sm_dtl{      
        text-align:center;
        p{
          color:#5B6683; font-size:14px;
          & + p{margin-top:10px;}
          .ttlp_lv{
            color: #53A869; position: relative; display: inline-block; font-weight: 500; padding-left: 10px;
            &:after{
              content: ''; width: 7px; height: 7px; background: #53A869; position: absolute; left: 0px; top: 7px; border-radius: 50%;
            }
          }
          .ttlp_wr{color:#FF6100;display: inline-block; font-weight: 500;}
        }
      }
  
    }
  
  
    .plsection{
      .head{      
        display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;
        h3{
          font-size: 16px; font-weight: 500;
        }
        label{
          background: #FF6100; color: #fff; padding: 2px 7px; display: inline-block; border-radius: 3px;
        }
      }
      .plr_list{
        display:flex; position: relative;
        &:after{
          content:''; background: #969CA6; position: absolute; left: 0px; right: 0px; margin: auto; top: 0px; bottom: 0px; width: 1px;
      }
        .cell{
              width: 50%;
    display: flex;
    justify-content: space-between;
    padding: 0 45px;
          &.cell:nth-child(1){
            // .cellsub{text-align:left;}
            
          }
  
          .cellsub{
            text-align:center;
            .media{
              width:70px; margin: auto; height:70px; overflow:hidden; border-radius:50px;
              img{
                width:100%;     object-fit: cover;
                object-position: top; height:100%;
              }
            }
            h3{
              color:#5B6683;
            }
          }
        }
      }
    }
    .badge-page .ant-pagination {
      display: none;
  }
    .plr_list_edit{
      display:flex; position: relative;padding-bottom:20px;margin-bottom:20px;border-bottom:1px solid #ccc;
      
  
      .cell{
        width: 50%; display: grid; grid-template-columns: 1fr 1fr;
        
          .cellsub{
            text-align:center; position: relative;
            .media{
              width:75px; margin: auto;height:75px; overflow:hidden; border-radius:50px;
              img{
                width:100%; height:100%;
              }
            }
  
            h3{
              color:#5B6683;
            }
            .trfyimg{
              position: absolute; right: 0px; top: -10px; width: 23px;
            }
          }
         
  
        }
  
        .score_bx {
          width: 50%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
  
      
  
      .ant-form-item-row{
        margin-left: 10px;
  
        input{
          width: 38px;
          height: 50px;
        }
      }
        }
      }
  
  
    
  
      .plr_list_edit:last-child{
        border:0px;
      }
  
  
      .mtch_dtls_modal{
        .ant-modal-content{height:100%;
          .ant-modal-close{    inset-inline-end: 10px !important; top: 12px !important;}
          .ant-modal-body{max-height:100% !important;}
          .ant-modal-footer{display:flex; justify-content:end;}
        }
      }


      .cstmmdlright.right-modal{
        .ant-modal-content{
          .ant-modal-body{
            height: calc(100vh - 130px); overflow: auto;
           
            
            .ant-spin-container{
              .ques_card{
                .head_bx{
                  .ant-row{
                    top:6px; right:6px;
                  }
                }
              }
            }
            
          }
          
          .ant-modal-footer{
            padding: 15px; margin: 10px 0px 0px 0px; text-align: left;
          }
        }
      }

 .plsection .plr_list.plr_list03 .cell .cellsub .media img {
        object-fit: cover;
        object-position: top;
        max-width: 70px;
    }
    
    .plsection .plr_list.plr_list03 .cell .cellsub .media {
        width: 70px;
        height: 70px;
    }
    
    .plsection .plr_list.plr_list03 .cell {
        width: 100%;
        display: grid;
        grid-template-columns:1fr 1fr 1fr 1fr ;
        align-items: center;
        justify-content: center;
    }
    
    .plsection .plr_list.plr_list03 .cell .add_bydef {
        width: 70px;
        height: 70px;
        margin: 0;
    }

    .plsection .plr_list03 {}

.plsection .plr_list03 .cell {
    flex-wrap: wrap;
    gap: 10px;
    align-items:flex-start !important;
    padding: 0px 35px;
}

.plsection .plr_list03 .cell .cellsub {
    width: 100%;
}

.plsection .plr_list03 .cell .cellsub .media {
    width: 40px !important;
    height: 40px !important;
}
.mtch_dtail .plsection .plr_list03 .cell .add_bydef{
 width: 40px !important;
    height: 40px !important;
}
.plsection .plr_list03 .cell .cellsub  h3 {
    font-size: 10px;
    margin-top: 5px;
}

.cell_wrap {
    width: 100%;
}

.cell_wrap h2 {
    margin-bottom: 20px;
    color: #000;
    font-weight: 500;
    text-align: center;
}

      .plsection .plr_list.plr_list02 .cell .cellsub .media img {
        object-fit: cover;
        object-position: top;
        max-width: 70px;
    }
    
    .plsection .plr_list.plr_list02 .cell .cellsub .media {
        width: 70px;
        height: 70px;
    }
    
    .plsection .plr_list.plr_list02 .cell {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .plsection .plr_list.plr_list02 .cell .add_bydef {
        width: 70px;
        height: 70px;
        margin: 0;
    }
    .sm_pndl .sm_mttl .media {
      width: 60px;    height: 75px;
      display: flex;
      align-items: center;
  }
  
  .sm_pndl .sm_mttl .media img {
    max-width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }

  .text_Quill .ql-container.ql-snow {
    height: 105px!important;
}
.option_ques_edit .option_item {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 0 -5px;
}

.option_ques_edit .option_item .ant-form-item {
  padding: 0 5px;
}
.question_ans .ad .ques_no h3 +h3 {
  margin-top: 5px;
  margin-left: 20px;
}
.table_list_dta table {}

.table_list_dta table tr {}

.table_list_dta table tr th:nth-child(2) {
    width: 20%;
}

.table_list_dta table tr th:nth-child(4) {
    width: 10%;
}

.table_list_dta table tr th:last-child {
    width: 15%;
}

.table_list_dta .ant-space-item .ant-btn {
    height: 22px;
    line-height: 14px;
    font-size: 12px;
    border-radius: 4px;
}
.dot_icon_drop .anticon-more {}

.dot_icon_drop .anticon-more svg {
    width: 40px;
    height: 20px;
    color: #000;
}
.dot_icon_drop .anticon-more {}

.dot_icon_drop .anticon-more svg {
    width: 40px;
    height: 20px;
    color: #000;
}

.d-flex{display:flex;}

.wd_dta_modal {}

.wd_dta_modal p {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 5px;
}

.wd_dta_modal p span {}

.wd_dta_modal p span:last-child {
    font-weight: 500;
    margin-left: 7px;
}

.wd_dta_modal .frm_dta .ant-row {
    display: block;
    text-align: left;
}

.wd_dta_modal .frm_dta .ant-row label {
    display: block;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    height: auto;
}

.wd_dta_modal .btn_grp {
    text-align: right;
}

.wd_dta_modal .btn_grp .ant-btn {
    color: #fff;
    background-color: #53a869;
    box-shadow: 0 2px 0 rgba(8, 102, 22, 0.15);
    width: 110px;
}

.wd_dta_modal .btn_grp .ant-btn +.ant-btn {
    margin-left: 15px;
    background: #dd3838;
    color: #fff;
}
.wd_dta_modal p span:first-child {
  width: 30%;
  display: inline-block;
}

.wd_dta_modal p {
  margin-bottom: 10px;
}
.clickable-row {
  cursor: pointer;
}



.frm_StartTime {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  max-width: 70%;
}

.frm_time {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  width: 70%;
}

.frm_StartTime .ant-picker-input >input {
  width: 100%;
}

.frm_StartTime label {
  margin-bottom: 21px;
  margin-right: 12px;
}

.frm_time .ant-col {
  max-width: 68%;
}

.frm_StartTime .ant-picker {
  width: 100%;
}

.time_wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 60%;
  justify-content: center;
  margin: auto;
  gap: 10px;

  .time_bx{
    .ant-col{max-width: 100%;
      .ant-picker{    width: 100%;}
    }
  }
  .time_bx_2{
    .ant-col{max-width: 80%;
      .ant-picker{    width: 100%;}
    }
  }
}



.packForm .warp_inner {}

.packForm .warp_inner .ant-row .ant-row {
    display: block;
    text-align: left;
    margin: 0;
}

.packForm .warp_inner .ant-col .ant-col {
    max-width: 100%;
    padding: 0 15px;
    padding-left:0;
}

.packForm .warp_inner .ant-row {
    // margin: 0 -15px;
}

.packForm .warp_inner .ant-row .ant-row label {
    text-align: left;
    width: 100%;
}



.packForm .warp_inner .ant-select-selector {
    height: 32px!important;
    border-radius: 3px;
}

.packForm .warp_inner .ant-select-selector .ant-select-selection-search-input {
    height: 28px!important;
}

.packForm .warp_inner span.ant-select-selection-placeholder {
    line-height: 31px!important;
}

.packForm .warp_inner .ant-form-item {
    margin-bottom: 15px;
}
.packForm .warp_inner .pack_date {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: end;
    gap: 15px;
    padding: 0 0;
}

.packForm .warp_inner 
 .pack_date .ant-col {
    padding: 0;
}
.packForm .warp_inner .ant-btn {
    margin: 0 15px;
    float: right;
}
.packForm .warp_inner .lab_bx {
    padding: 0 0px;
    max-width: 100%;
    height: 32px;
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    display: inline-flex;
}
    .book_pack_wrapp p {
    font-size: 16px;
    font-weight: 400;
    color: #000;
    margin-bottom: 10px;
}

.book_pack_wrapp p span:last-child {
    font-weight: 500;
}
.book_pack_wrapp{margin-top:30px;}
.book_pack_wrapp p span:first-child {
    width: 45%;
    display: inline-block;
}
    .packForm .alart_wrapp { position: absolute; width: 100%; left: 0; top: -50px; }

.packForm {
    position: relative;
}
.packForm .warp_inner .ant-select-multiple .ant-select-selector {
    height: auto!important;
}
    .packForm textarea {
    min-height: 130px;
}
.packForm .ant-radio-group {
    display: flex;
    margin-top: 18px;
}
.pckg_wrapp .sc-iBYQkv {
    display: flex;
   flex-wrap:wrap;
    gap: 0 15px;
}
.packForm .ant-radio-group label {width: max-content !important}
.sc-iBYQkv.ewamOi {}

.pckg_wrapp .sc-iBYQkv {
    gap: 0 15px;
}

.card_pk_details {
    border: 1px solid #f0f0f0;
    margin-top: 20px;
    padding: 15px;
    position: relative;
}

.card_pk_details h3 {
    position: absolute;
    top: -11px;
    z-index: 2;
    font-size: 14px;
    background: #fff;
    display: inline-block;
    padding: 0 5px;
    font-weight: 500;
}

.card_pk_details .bk_inner {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 10px;
}

.card_pk_details .bk_inner p {
    font-size: 13px;
}
.table_pckge .ant-table-cell{
    white-space: nowrap;
}

.table_pckge .ant-table-content {
    overflow: auto;
}
.card_pk_details .bk_inner p span:last-child {display: block;font-weight: 500;}



.quill.editor-large .ql-container .ql-editor{min-height:150px;}
.grpview-table .ant-table-cell .ant-space {
    display: block;
}

.rept_table thead {}

.rept_table thead th {
    white-space: nowrap;
}

.rept_table tbody td .ant-space {
    display: block;
}

.rept_table tbody td:first-child .ant-space .ant-space-item:first-child {
    display: -webkit-box;
    max-width: 100%;
    margin: 0 auto;
    line-height: 1;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 22px;
    text-overflow: ellipsis;
    margin-bottom: 10px;
}

.rept_table thead th:first-child {
    width: 30%;
}

.rept_table tbody td:first-child .ant-space .ant-space-item {
}

.rept_table .ant-table-cell .mediagrp .ant-image {
    width: 45px;
    height: 45px;
    overflow: hidden;
    border-radius: 8px;
    margin: 6px;
}
.rept_table .ant-table-cell .mediagrp {
    display: grid;
    align-items: center;
    grid-template-columns: repeat(2,1fr);
    margin: -6px;
}



.rept_table thead th:nth-child(2) {
    width: 10%;
}

.rept_table thead th:nth-child(3) {
    width: 15%;
}
.rept_view_table .ant-space {
    display: block;
}
.rept_table thead th:last-child {
    width: 85px;
}
    .btn_rpt {
    width: 47px;
    margin: 0 auto;
    background: #f9d1d9;
    text-align: center;
    border-radius: 12px;
    color: #000;
}
  
.editorrrr .ql-editor {
    text-align: right;
}
    .pckg_wrapp .sc-iBYQkv .ant-form-item {
    width: 23.6%;
}

.pckg_wrapp .sc-iBYQkv .ant-form-item:nth-child(6) {
    width: 30%;
}

.table_pckge .ant-table-thead th:nth-child(5),.table_pckge td:nth-child(5) {
  text-align: center;
}
.cancelled {
    color: #FF0000; /* Red color for cancelled status */
}

.booked {
    color: #76B584; /* Green color for booked status */
}
    .ql-editor {
    height: 180px !important;
}
    .editer_text .ant-modal-footer {
    padding: 0px 30px!important;
    border: 0px!important;
    margin: 0px!important;
    display: flex;
    justify-content: end;
}

.bk_det_modal .isYBtm {
    overflow: initial;
    max-height: 100%;
}

.bk_det_modal  .ant-modal-body {
    height: 295px;
    overflow-y: auto;
    padding-right: 15px;
    margin-right: -15px;
}
ul.bk_dta li span{color:#000; font-size: 12px;
    font-weight: 300;}
.bk_det_modal  .ant-modal-body::-webkit-scrollbar {
  width: 3px;
}
.bk_det_modal  .ant-modal-body::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
.bk_det_modal  .ant-modal-body::-webkit-scrollbar-thumb {
  background: #76b584; 
  border-radius: 10px;
}
.bk_det_modal  .ant-modal-body::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
.bk_dta_info_wrapp ul.head_bkx {
    display: flex;
    align-items: start;
    gap: 15px;
}
.bk_dta_info_wrapp{    display: block;}
.bk_dta_info_wrapp ul.head_bkx li {
    font-size: 13px;
}
    .bk_info_dta {}

.bk_info_dta .head_bx {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bk_info_dta .head_bx h3 {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.88);
    font-weight: 400;
}

.bk_info_dta .head_bx p {
    color: #000;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
}


.bk_info_dta ul {
    padding-left: 30px;
    margin: 3px -3px 0;
    display: flex;
    flex-wrap: wrap;
}

.bk_info_dta ul li {
       background: #f5f5f5;
    border-radius: 100px;
    text-align: center;
    padding: 5px 6px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.8);
    display: flex;
    margin: 3px;
    line-height: normal;
    gap: 3px;
    align-items: center;
}
.bk_info_dta .head_bx h3 span {
    margin: 0 15px 0 0;
}
.bk_info_dta ul li span {}
.bk_info_dta .head_bx h3 span {
    margin: 0 15px 0 0;
}

.bk_det_modal .ant-modal-body .bUvPSW {
    gap: 40px;
}
.bk_info_dta ul li span {}

.bk_info_dta ul li span:first-child {
    color: #000;
    font-weight: 500;
}


.bk_info_wp {
}

.bk_info_wp h3 {}

.bk_info_wp h3 span:last-child {
    display: block;
    color: #53a869;
}

.bk_info_wp h3 >span:first-child {display: flex;align-items: center;color: rgba(0, 0, 0, 0.88);font-weight: 400;font-size: 14px;}

.bk_info_wp h3 span:first-child span {
    margin: 0 15px 0 0;
    color: rgba(0, 0, 0, 0.6);
}



bk_info_wp .bk_info_inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bk_info_wp .bk_title {
    display: flex;
    align-items: center;
    width: 100%;
}

.bk_info_inner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bk_info_wp .bk_title .anticon {
    margin: 0;
    margin-right: 15px;
    color: rgba(0, 0, 0, 0.6);
}


.main_bx {
    padding: 20px 20px 20px;
}

// .packForm .warp_inner .ant-row .ant-row .ant-col.ant-col-10 {
//     padding: 0 0 0 15px;
// }


.packForm .warp_inner .ant-checkbox-group {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.fld_w_wrap {
    display: flex;
    align-items: center;
}
.arr_frm .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    right: -20px;
}
.companyTNC .ant-table-tbody > .ant-table-row .ant-table-cell > div {
    max-height: 200px;
    overflow: auto;
}


.cstmtablecs{
  width: 100%;height: 100%;
.role_wrap{
width: 100%;display: flex;
.sidebar{max-width: 260px;height: calc(100vh - 180px);width: 260px;background: #EBEBEB;
.side_bx{margin: 0 !important;
.search_bx{padding: 15px;
.ant-space-compact{
.ant-input-group-wrapper{border: 1px solid #BEBEBE;border-radius: 8px;
.ant-input-wrapper{
.ant-input-group-addon{background: #fff;border: 0;padding-right: 0;
.anticon{
svg{    fill: #5B6683;}
}
}

.ant-input{border:0px;
&::placeholder {
color:#5B6683;
font-size:13px;
}
}
}
}
}
}
.rle_mnu_itm{
margin-top:15px;
  .add_lnk{border: 0;background: 0;color: #179A39;font-size: 16px;font-weight: 500;padding: 0 15px;     box-shadow: none;}
  .rol_menu{    margin-top: 0px;
     li{padding:8px 15px; width: 100%; border-bottom: 1px solid #D9D9D9;
     &:last-child{border-bottom:0px;}
     .rol_lnk{border: 0;width: 100%;box-shadow: none;background: none;border-radius: 0;    text-align: left;     padding: 0;height: 100%; color: #151515;font-weight: 500;}
       }
    }
  }
}
}

.permisson{width: 100%;margin-left: 15px;background: #fff;padding:15px;

   .pems_head{display: flex;justify-content: space-between;align-items: center;background: #F5F5F5;padding: 10px;
   h4{    font-size: 18px;font-weight: 500;}
   .perms_btn{display:flex;
    .save_btn{background: #18A159;color: #fff;border: none;border-radius: 5px;padding: 6px 25px;margin-right: 10px;}
    .rset_permsn{border: 1px solid #EB4226;color: #EB4226;border-radius: 5px !important;font-size: 15px;font-weight: 400;}
   }
   }
   .perms_list_wrap{margin-top:15px;
     .permsn_list{
       li{padding: 10px;width: 100%;background: #FCFCFC;border-bottom: 1px solid #EFEFEF;display: grid;grid-template-columns: 30% 70%;
       & + li{background:#fff;
       span{font-weight:400;}
       }
       span{font-size:16px; font-weight:500;}
       .ant-checkbox-wrapper{
        .ant-checkbox{
          .ant-checkbox-input{}
           .ant-checkbox-inner{border: 1px solid #00473a;border-radius: 2px;}
        }
           .ant-checkbox-checked{
           .ant-checkbox-inner{background:#00473a;}
           }
       }
       }
     }
   
    }

  
}
}
}





.offen_box {
    background: #fff;
    width: 100%;
    height: calc(100vh - 337px);
    padding: 15px;
    max-height: 100%;
    overflow: auto;
}

.offen_box .nte_ofen {
    background: #6d6e710f;
    padding: 3px 10px;
}

.offen_box .nte_ofen span {
    color: #202021;
    font-size: 16px;
    font-weight: 400;
}

.add_wrd_wrap {
    margin-top: 20px;
}

.word_bx {
    background: #F3F3F3;
    padding: 10px;
    width: max-content;
    min-width: 130px;
    position: relative;
    // margin-right:15px;
    margin-bottom:20px;
}
    .word_bx + .word_bx {
    margin-left: 12px;
}
.crss_icon button {
    background: none;
    border: none;
    padding: 0;
    height: unset;
}
.word_bx span {
    display: block;
    font-size: 16px;
    color: #000;
}

.crss_icon {
    position: absolute;
    top: -10px;
    right: -9px;
}

.crss_icon span.anticon {
    font-size: 22px;
    color: #D81616;
}

.word_bx span + span {
    color: #5B6683;
}
.offensive-words{
  display: flex;
  justify-content: space-between;
  gap: 1rem; 
}


.add_wrds_mdl .ant-modal-body {
    height: calc(100vh - 150px);
    display: flex;
    align-items: center;
}

.add_wrds_mdl .ant-modal-body {
    height: 100% !important;
    display: flex;
    align-items: center;
    width: 100%;
}

.add_wrds_mdl .ant-modal-body form .add_wrd_bx {
    width: 100%;
    display: inline-block;
    justify-content: center;
    // border: 1px solid #ccc;
    // padding: 20px;
    border-radius: 4px;
        margin-top: 16px;
}

.add_wrds_mdl .ant-modal-body form {
    width: 100%;
    padding: 10px;
        padding-bottom: 0;
            padding-top: 0
}

.add_wrds_mdl .ant-modal-body form .add_wrd_bx button.ant-btn {
    margin-right: 20px;
    background: #fff;
    color: #2a2a2a;
    display: block;
    font-size: 15px;
    padding: 4px 35px;
    height: auto;
    // margin: auto;
    margin-bottom: 10px;
    margin: auto;
       margin-bottom: 11px;
}

.add_wrds_mdl .ant-modal-body form button + button {
    // background: #002720;
    // color: #fff;
}

.add_wrds_mdl .ant-modal-body form .add_wrd_bx button.ant-btn + button {}

.btn_wrap {text-align: center;}

 button.add_btn {
    background: #00473a;
    color: #fff !important;
    padding: 4px 20px !important;
    margin-right: 10px;
}

.add_spin .ant-spin {
    width: 100%;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
}

.add_spin {
    width: 100%;
    height: calc(100vh - 340px);
}

.smple_btn {
    border: none;
    background: none;
    box-shadow: none;
    color: #00473a;
}
    .btn_wrap{}


.add_wrds_mdl  .ant-modal-header {
    margin-bottom: 10px !important;
}

.add_wrds_mdl .ant-modal-footer {
    display: none;
}

.hd_btn {
    text-align: right;
}


.foot_btn {
    display: flex;
    justify-content: end;
    margin-top:20px;
    border-top: 1px solid #ddd;
    padding-top: 10px;
}

.foot_btn button + button {
    margin-right: 0 !important;
}

.hd_btn button.sam_btn {
    border: 0px !important;
    box-shadow: none;
    color: #00473a;
    font-weight: 500;
    padding:0;
}

.btn_danger{
    color: #ff4d4f !important;
    border-color: #ff4d4f !important;
}


.no_data {
    width: 100%;
    height: calc(100vh - 400px);
    display: flex;
    justify-content: center;
    align-items: center;
}


.crd_list {
    justify-content: flex-start;
    gap: 20px
}

.crd_list .ant-card {}

.crd_list .ant-card .ant-card-body {
    padding: 10px;
}

.crd_list .ant-card .ant-card-body span + span.ant-typography {
    margin-top: 14px;
}

.crd_list .ant-card .ant-card-body .reprt_btn {
    margin-top: 14px;
}
.offen_pagination{display:flex; justify-content:end;padding-top:30px;}
// .reactEasyCrop_CropArea{
// width:1500px !important;
// height:900px !important;
// border:none !important;
// }



.mtch_dtail .sm_pndl {
    margin-top: 20px;
    text-align: left;
}

.mtch_dtail .sm_pndl .smpnm {
    background: #f1f0f0;
    justify-content: left;
    padding: 3px 20px;
    align-items: center;
}

.mtch_dtail .sm_pndl .sm_mttl {justify-content: space-between;margin-bottom: 20px;margin-top: 20px;     align-items: flex-start;}

.mtch_dtail .sm_pndl .sm_mttl .dtl_pr {
    display: flex;
    align-items: center;
}

.mtch_dtail .sm_pndl .sm_mttl .dtl_pr .media {
    width: 68px;
    height: 68px;
    display: block;
        border-radius: 50%;
}

.mtch_dtail .sm_pndl .sm_mttl .dtl_pr .media img{border-radius:50%;}

        .mtch_dtail .sm_pndl .sm_mttl .dtl_pr .media{ border-radius: 50%;
        }

.mtch_dtail .sm_pndl .sm_mttl .sm_dtl {
    text-align: right;
}


.mtch_dtl_frm {}

.mtch_dtl_frm .plsection {}

.mtch_dtl_frm .plsection .plr_list_edit {
    display: flex;
    justify-content: left;
}

.mtch_dtl_frm .plsection .plr_list_edit .cell {
    display: block;
        width: auto;
}

.mtch_dtl_frm .plsection .plr_list_edit .cell .cellsub {    text-align: left;}

.mtch_dtl_frm .plsection .plr_list_edit .cell .cellsub .media {
    width: 50px;
    height: 50px;
}


.jn_req {}

.jn_req h2 {
    font-size: 18px;
}

.rqst_wrap {
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
   max-height: calc(100vh - 390px);
       height: auto;

     overflow:auto;

    }
.jn_req .rqst_list {
       width: 33.3%;
}

.jn_req .rqst_list .reqst_bx {
    display: grid;
    // align-items: center;
    grid-template-columns: 40px 1fr;
    margin-right: 20px;
    margin-bottom:20px;
}

.jn_req .rqst_list .reqst_bx .media {
    width: 42px;
    height: 42px;
    overflow: hidden;
    position: relative;
    margin-right: 10px;
    border-radius:40px;
}

.jn_req .rqst_list .reqst_bx .media img {
    width: 100%;
    height: 100%;
}

.jn_req .rqst_list .reqst_bx .rqst_dtls {
    margin-left: 10px;
}

.jn_req .rqst_list .reqst_bx:nth-child(3) {
    margin-right: 0;
}

.rqst_dtls {}

.jn_req .rqst_list .reqst_bx .rqst_dtls span {
    font-size: 14px;
    display:block;
}
    .jn_req {
    border-top: 1px solid #ebeaea;
    padding-top: 20px;
    margin-top: 10px;
}

.mtch_dtl_frm{position:relative;}


.mtch_dtail .plsection .plr_list .cell .cellsub .media {
    width: 55px;
    height: 55px;
}

.mtch_dtail .plsection .plr_list .cell .add_bydef {
    width: 55px;
    height: 55px;
}

.join_ttl{
display:flex;
justify-content:space-between;
}

.no_dataemty {
    width: 100%;
}

.mtch_dtail {
    width: 700px !important;
}


.mtch_dtail .ant-modal-content .ant-modal-body {
    height: auto;
}


.sidebarl::-webkit-scrollbar {
  width: 5px;
}


.sidebarl::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 

.sidebarl::-webkit-scrollbar-thumb {
  background: #888; 
}


.sidebarl::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.card_row{width:100%;
.op_cl{width:100%;
h4{font-size: 18px;
    margin-bottom: 10px;
    font-weight: 500;}
.op_cl_bx{
    display: flex;
    width: 100%;
    align-items: center;

    .card_wrap{
    background: #fff;
    padding: 14px;
    width: 25%;
        border-radius: 5px;
    box-shadow: 1px 1px 14px #e3e1e1;

    & + .card_wrap{
    margin-left:10px;
    }

    .card_bx{
    span{font-size:13px; font-weight:500; margin-bottom:5px; display:block; color:#fff;}
    h3{font-size: 16px;font-weight: 500; color:#fff;}
    }
    }
}
}
}


.card_row .ant-space-item {
    margin-bottom: 10px;
}

.op_cl h4 {
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: 500;
}

.card_bx {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card_bx .bx_icon {}

.card_bx .bx_icon img {
    width: 40px;
}

.dtls_notify {}

.dtls_notify .ant-modal-body {
    padding: 20px !important;
}

.dtls_notify .ant-modal-body form {}

.dtls_notify .ant-modal-body form .ant-row {}

 

.dtls_notify .ant-modal-body form label {
    font-weight: 500 !important;
}

.dtls_notify .ant-modal-body form .arb_notify {}

.dtls_notify .ant-modal-body form .arb_notify p {
    font-weight: 500;
}

.dtls_notify .ant-modal-body form .arb_notify .arb_dtls p {
    font-weight: 400;
}

.dtls_notify .ant-modal-body form .arb_notify .arb_img {
    margin-top: 10px;
}

.dtls_notify .ant-modal-body form .arb_notify .arb_img .ant-image {
    width: 120px;
}

.dtls_notify .ant-modal-body form .arb_notify .arb_img .ant-image img {
    height: 100%;
}

.dtls_notify .ant-modal-body form .ant-row .ant-col .data_bx {
    width: 100%;
    border: 1px solid #cccc;
    padding: 6px;
    display: block;
    border-radius: 4px;
    margin-top: 10px;
}

.arb_dtls {}

.notify_form {}

.notify_form form {
    // flex-wrap: wrap;
}

.notify_form form .sc-hLBbgP {
    // width: auto !important;
}

.action_col {
    text-align: end !important;
}

.close_icon span{
    position: absolute;
    top: 0px;
    right: 0;
    font-size: 10px;
    color: rgb(225 11 13);
    cursor: pointer;
    background: #f7d4d4;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
}


.add_mre {
    display: flex;
    justify-content: end;
} 

.add_mre button {
    border: none;
    color: #0060DD;
    font-size: 16px;
}

.slot_wrap .slot_mbl .nbsbx{}
.slot_wrap .slot_mbl .nbsbx .nbs_nme {}
.slot_wrap .slot_mbl .nbsbx .nsprng{}
.slot_wrap .slot_mbl .nbsbx .nsprng .ngprbx{ width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 20px 10px 0px 10px; bottom:unset; top:23px;}
.slot_wrap .slot_mbl .nbsbx .nsprng .ngprbx span{font-size:15px;}

.onlybookslts{
  .bokd_slot{
    .sc-GhhNo{
      .sc-fbYMXx{
        justify-content: flex-start; margin: 0px;
      }
    }
  }
}

.slot_mbl .halfHours .newsltbxablb span{font-size:16px;}
.text-white{color:#fff;}
.fw-500{font-weight:500}



.day_view_clg .sc-jfTVlA{grid-template-rows: 120px auto;}
.day_view_clg .sc-jfTVlA .sc-iOeugr .sc-jfvxQR .field_mbl .sc-cOxWqc{display:none;}
           






.facily_head{
position:relative;
}
.facily_head .ant-tabs-nav {
    background: #fff;
    padding: 10px 20px;
    border-radius: 10px;
}
.filter_srch {
   background: #fff;
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid #cccccc59;
}

.filter_srch label{font-weight:500;}

.use_bx_b{display:flex;     
justify-content: space-between;
    align-items: start;
    margin-top: 10px;}

    .bh_card {
    max-height: 164px;
}
@keyframes bell-shake {
  0% { transform: rotate(0deg); }
  25% { transform: rotate(10deg); }
  50% { transform: rotate(-10deg); }
  75% { transform: rotate(10deg); }
  100% { transform: rotate(0deg); }
}
.bh_card .ant-card-body {
    padding: 20px 20px 0;
    min-height:120px;
}
    .use_bx_b img{width:22%;}


    .count_n .ant-badge-count {
    width: 16px;
    height: 16px;
    min-width: 16px;
    font-size: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
}
ul.ant-pagination .ant-pagination-options{
          display: inline-block !important;
}

@media(max-width:900px){
.card_row_main {
    display: grid !important;
    grid-template-columns: 50% 50% !important;
}

.card_row_main .ant-col.ant-col-6 {
    width: 100% !important;
    max-width: 100% !important;
}

.graph_row .ant-col-12 {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
}
    .filter_srch{
    flex-wrap:wrap;
    }


    .filter_srch .ant-space-item {
    width: 100%;
}

.filter_srch .ant-space-item .ant-select {
    width: 100% !important;
}
    .filter_srch .ant-space-item .ant-picker{
    width:100% !important;
    }

    .filt_btn{gap:10px; display:flex; margin-top:20px;}

    
    .res_bx{
    display:grid !important;
    grid-template-columns: 1fr 1fr !important;
    }

    .res_bx .card_wrap {
    width: 100% !important;
    min-height:110px;
}

.card_row_main h4 {
    font-size: 20px !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
    .cstm_ph_field{width:32%;}

    .cstm_width {
    width: 120px;
}
  
}
 @media(max-width:900px){
.card_row_main {
    display: grid !important;
    grid-template-columns: 50% 50% !important;
}

.graph_Scroll {
  overflow-x: auto;
  width: 100%;
}

.graph_Scroll > div {
  min-width: 600px; /* Set minimum width based on your chart's actual size */
}

.chart-inner {
  min-width: 600px; /* or more if chart is wider */
}

.card_row_main .ant-col.ant-col-6 {
    width: 100% !important;
    max-width: 100% !important;
}

.graph_row .ant-col-12 {
    width: 100%;
    max-width: 100%;
    flex: 0 0 100%;
}
    .filter_srch{
    flex-wrap:wrap;
    }


    .filter_srch .ant-space-item {
    width: 100%;
}

.filter_srch .ant-space-item .ant-select {
    width: 100% !important;
}
    .filter_srch .ant-space-item .ant-picker{
    width:100% !important;
    }

    .filt_btn{gap:10px; display:flex; margin-top:20px;}

    
    .res_bx{
    display:grid !important;
    grid-template-columns: 1fr 1fr !important;
    }

    .res_bx .card_wrap {
    width: 100% !important;
}

.card_row_main h4 {
    font-size: 20px !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
}
.socia_chart.drill-active {
  overflow-x: auto;
  }
  .bh_card .ant-card-body {
    padding: 20px 20px 0;
    min-height:120px;
    }
  .note_payment{
   color:red
  }
       .cstm_ph_field{width:100%}
       .cstm_width{width:100% !important}
}
 .aprv_btn {
    font-size: 12px;
    padding: 3px;
    height: auto;
}
/* 1. Target the text and add a custom underline when active */
.unavailable-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: red !important;
  border-bottom: 2px solid red; /* This creates the red underline in your drawing */
  padding-bottom: 4px;
}

/* 2. Optional: Force the Ant Design animated underline (ink-bar) to also be red */
.unavailable-tab.ant-tabs-tab-active ~ .ant-tabs-ink-bar {
  background-color: red !important;
}

/* 3. Ensure the text stays red even when not active (as per your code) */
.unavailable-tab .ant-tabs-tab-btn {
  color: red;
}
  .full-width-invoice-item {
  grid-column: 1 / -1; /* If using CSS Grid, this forces it to take the full row */
  width: 100%;
}

/* Target the value specifically if you know the internal class */
.full-width-invoice-item .value-class-name { 
  white-space: nowrap;
  display: block;
}

.onlydsk{ width:100% !important; }
.onlydsk .ant-row {}
.onlydsk .ant-row .ant-col-10{max-width:136px !important;}






@media(max-width:1366px){


.order-id_a {
    min-width: auto !important;
    // margin-left: 50px !important;
}
    
}



.badge_ttl{
  background: #dae8db !important;
width:20px;
height:20px;
display:flex;
align-items:center;
justify-content:center;
border-radius:20px;
}

.welcome_pge{
widh:100%;
height:100%;
display: flex;
justify-content:center;
align-items:center;
}

.welcome_pge img {
margin:auto;
text-align:center;
}

.welcome_pge h2{
font-size:30px;
font-weight:500;
color :#00473A;
text-align:center;
margin-top:10px;
}

.form_main_wrap form {
    flex-wrap: wrap;
}

.form_main_wrap form  .withdraw_form_list {}

.form_main_wrap form .withdraw_btn {
    width: auto;
    margin-top:0;
}

.filter-select-height {
  font-size: 12px !important;

  .ant-select-selector {
    height: 29px !important;
    font-size: 12px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: 28px !important;
    font-size: 12px !important;
  }

  .ant-select-selection-search-input {
    height: 28px !important;
    font-size: 12px !important;
  }
}

`;
